export default "__VITE_ASSET__CIfwgHRe__"